// Moderator actions: "Accept as guide" in a Guides discussion's menu (+150 EXP to its author, POST
// /api/aethernal/gamify/guide) and the "Accepted guide" badge on such discussions. Awarding / revoking the team's
// achievements (Bug Hunter, Event Winner, Founder corrections) is on the member's Progress page (ProgressPage.tile).
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import Badge from 'flarum/common/components/Badge';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import UserControls from 'flarum/forum/utils/UserControls';
import { t, ts, api } from './ui';
const inGuides = discussion => (discussion.tags && discussion.tags() ? discussion.tags() : []).some(tag => tag && (tag.slug() === 'guides' || tag.parent && tag.parent() && tag.parent().slug() === 'guides'));
export default function addManage() {
  extend('flarum/common/models/Discussion', 'badges', function (items) {
    if (this.attribute('aetGuide')) {
      items.add('aetGuide', m(Badge, {
        type: "aetGuide",
        icon: "fas fa-book-open",
        label: ts('guide_badge')
      }), 5);
    }
  });
  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    if (!app.forum.attribute('aetCanManage') || !inGuides(discussion)) return;
    const on = !!discussion.attribute('aetGuide');
    items.add('aetGuide', m(Button, {
      icon: on ? 'fas fa-book' : 'fas fa-book-open',
      onclick: () => api('POST', '/aethernal/gamify/guide', {
        discussion: discussion.id(),
        on: !on
      }).then(() => {
        discussion.pushAttributes({
          aetGuide: !on
        });
        m.redraw();
      })
    }, on ? t('guide_unaccept') : t('guide_accept')));
  });

  // the member menu on cards/profiles: a shortcut to the award buttons on their Progress page
  extend(UserControls, 'moderationControls', function (items, user) {
    if (!app.forum.attribute('aetCanManage')) return;
    items.add('aetAward', m(Button, {
      icon: "fas fa-medal",
      onclick: () => m.route.set(app.route('user.aetAchievements', {
        username: user.slug()
      }))
    }, t('manage_button')));
  });
}
flarum.reg.add('aethernal-forum', 'forum/gamify/manage', addManage);